import styles from './TierUpsellSection.module.scss';
import { useGetUser, useTierConfig } from 'src/hooks';
import { useCallback, useMemo } from 'react';
import { AppRoutes, UserTier } from 'src/types';
import { Button } from 'src/v2/commonComponents/Button';
import { useNavigate } from 'react-router-dom';
import { UpgradeButton } from 'src/components/UpgradeButton';
import { RemainingSuperNinjaTasksSection } from 'src/pages/ManageTasksChatPage/components/SidePanel/components/SideSettingsSections/WalletSection/components/RemainingTasksSection';
import { TrialDaysSection } from 'src/pages/ManageTasksChatPage/components/SidePanel/components/SideSettingsSections/WalletSection/components/TrialDaysSection';

export const TierUpsellSection = () => {
  const { labelShort } = useTierConfig();
  const { tierId, isOpenTier, isTrialTier, isFreeTier, isCreditTier } =
    useGetUser();
  const navigate = useNavigate();

  const handleSignUpClick = useCallback(() => {
    navigate(AppRoutes.SIGN_UP);
  }, [navigate]);

  const tierButton = useMemo(() => {
    switch (tierId) {
      case UserTier.OPEN:
        return (
          <Button
            color="highlight"
            onClick={handleSignUpClick}
            className={styles.actionButton}
          >
            Sign up for free
          </Button>
        );
      case UserTier.BUSINESS_SUPERNINJA_MAX:
        return <></>;
      default:
        return (
          <UpgradeButton
            dataGTM="file-list-upgrade"
            className={styles.actionButton}
            color="highlight"
          />
        );
    }
  }, [tierId, handleSignUpClick]);

  return (
    <div className={styles.root}>
      <div className={styles.sectionWrapper}>
        <div className={styles.tierRow}>
          {labelShort}
          {tierButton}
        </div>
        {/* {(isOpenTier || isFreeTier) && (
          <div className={styles.subsectionWrapper}>
            <RemainingTasksSection />
          </div>
        )} */}
        {isTrialTier && (
          <div className={styles.subsectionWrapper}>
            <TrialDaysSection />
          </div>
        )}
        {!isOpenTier && !isFreeTier && !isCreditTier && (
          <div className={styles.subsectionWrapper}>
            <RemainingSuperNinjaTasksSection />
          </div>
        )}
      </div>
    </div>
  );
};
